// extracted by mini-css-extract-plugin
export var container = "Metadata-module--container--5e76f";
export var divider = "Metadata-module--divider--0b4df";
export var link = "Metadata-module--link--a4725";
export var row = "Metadata-module--row--a4296";